export interface ICommunityInput {
  id?: number;
  title?: string;
  description?: string;
  splashImageUrl?: string;
  showApplicantReview?: boolean;
}
